import script from "./HowWeWork.vue?vue&type=script&setup=true&lang=js"
export * from "./HowWeWork.vue?vue&type=script&setup=true&lang=js"

import "./HowWeWork.vue?vue&type=style&index=0&id=6bf50dac&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bf50dac"]])

export default __exports__